export const sortByInCartThenSeq = (cartQtyByProduct) => ((a, b) => {
  const aCartQty = parseInt(cartQtyByProduct[a.prodkey]) || 0;
  const bCartQty = parseInt(cartQtyByProduct[b.prodkey]) || 0;

  const aHasQty = (aCartQty > 0) ? 1 : 0;
  const bHasQty = (bCartQty > 0) ? 1 : 0;

  return bHasQty - aHasQty || a.seq - b.seq;
});
